import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from 'app/base/services/custom-toast-service';
import { AttendanceCache } from 'app/services/models/user-detail-model';
import { CMSDynamicService } from 'app/services/yoklama/cms-service';
import { UtcTimeService } from 'app/services/yoklama/utc-service';
import { environment } from 'environments/environment';
declare const jsQR: any;

enum LocationStatus {
  OK = 'OK',
  WARNING = 'WARNING',
  FAIL = 'FAIL',
}

// ================= HUB CONNECTION =================
import {
  HubConnection,
  HubConnectionBuilder,
  HttpTransportType,
} from '@microsoft/signalr';
@Component({
  selector: 'app-student-attendance',
  templateUrl: './student-attendance.component.html',
  styleUrls: ['./student-attendance.component.css'],
})
export class StudentAttendanceComponent implements OnInit, OnDestroy {
  LS_KEYS = {
    IOS_LOCATION_INFO: 'ios_location_info_shown',
    IOS_CAMERA_INFO: 'ios_camera_info_shown',
    ANDROID_LOCATION_INFO: 'android_location_info_shown',
  };
  LS_ONBOARDING = 'attendance_onboarding_shown';
  ATTENDANCE_CACHE_KEY = 'attendance_cache';

  // ================= ROUTE =================
  ogrenciNo!: string;
  courseStartId!: number;
  createdDate!: Date;
  attendanceDuration!: number;
  studentName!: string;
  studentSurname!: string;
  ogrenciDersNo!: number;

  latitude!: number;
  longitude!: number;

  qrUretAktif = false;
  konumKontrolAktif = false;
  lessonName = 'Veri Tabanı Yönetim Sistemleri'; //querypamsdan alaınacak
  lessonSalaon = '';
  lessonGun = '';

  lessonStartTime = '10:00'; //querypamsdan alaınacak
  lessonEndTime = '10:50'; //querypamsdan alaınacak
  currentSlot = 1; //local storgaden alaıancak bir dünya şey var readLocalStorege metdhodu yazalım orda init edelim

  // ================= UI =================
  remainingSeconds = 0;
  timerRef: any;

  loading = false;
  attendanceSuccess = false;

  cameraOpen = false;
  qrRead = false;

  // ================= LOCATION =================
  locationAllowed = false;
  userLat!: number;
  userLng!: number;
  maxDistanceMeter = 100;
  attendanceCache!: AttendanceCache;
  attendancePercent = 0;
  cameraPermissionDenied = false;
  // ================= TOKEN =================
  currentToken = '';

  // ================= SIGNALR =================
  hub?: HubConnection;
  showOnboarding = false;
  // ================= CAMERA =================
  @ViewChild('video') video!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas') canvas!: ElementRef<HTMLCanvasElement>;
stream?: MediaStream | undefined | null;
  scanIntervalRef: any;
  butonGoster = false;

  qrHub?: HubConnection;
  attendanceHub?: HubConnection;

  token: string = '';
  students: any[] = [];
  userList?: any;

  tokenQr: String = '';
onboardingLocked = false; // 🔥 ONBOARDING AÇILDIĞINDA VEYA KAPATILDIĞINDA ASLA TEKRAR AÇILMASIN
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private alertService: CustomToastrService,
    private httpService: CMSDynamicService,
    private utcTimeService: UtcTimeService,
  ) {}
  private isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  private isAndroid(): boolean {
    return /Android/.test(navigator.userAgent);
  }
  private showIOSLocationInfoOnce(): void {
    if (!this.isIOS()) return;

    if (localStorage.getItem(this.LS_KEYS.IOS_LOCATION_INFO)) return;

    this.alertService.message(
      'iPhone kullanıyorsan konum doğruluğu için Ayarlar > Safari > Konum > Kesin Konum açık olmalı.',
      'Bilgilendirme',
      {
        messageType: ToastrMessageType.Warning,
        position: ToastrPosition.TopFullWidth,
      },
    );

    localStorage.setItem(this.LS_KEYS.IOS_LOCATION_INFO, '1');
  }
openOnboarding(): void {
  const alreadySeen = localStorage.getItem(this.LS_ONBOARDING) === '1';

  if (alreadySeen) return; // 🔥 tekrar açtırma

  this.showOnboarding = true;
}
 closeOnboarding(): void {
  if (this.konumKontrolAktif && !this.locationAllowed) {
    this.alertService.message('Konum izni alınmadan devam edilemez', 'Uyarı', {
      messageType: ToastrMessageType.Warning,
      position: ToastrPosition.TopFullWidth,
    });
    return;
  }

  if (this.qrUretAktif && this.cameraPermissionDenied) {
    this.alertService.message('Kamera izni alınmadan devam edilemez', 'Uyarı', {
      messageType: ToastrMessageType.Warning,
      position: ToastrPosition.TopFullWidth,
    });
    return;
  }

  localStorage.setItem(this.LS_ONBOARDING, '1');

  this.showOnboarding = false;
  this.onboardingLocked = true; // 🔥 artık asla açma
}
  // ================= PERMISSION ACTIONS =================

async requestLocationPermission(): Promise<boolean> {
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      () => {
        this.locationAllowed = true;
        this.locationPermissionState = 'granted';
        resolve(true);
      },
      (err) => {
        this.locationAllowed = false;
        this.locationPermissionState = 'denied';
        resolve(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  });
}

async requestCameraPermission(): Promise<boolean> {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: 'environment' }
    });

    stream.getTracks().forEach(t => t.stop());

    this.cameraPermissionDenied = false;
    this.cameraPermissionState = 'granted';

    return true;
  } catch (err: any) {
    this.cameraPermissionDenied = true;
    this.cameraPermissionState = 'denied';
    return false;
  }
}
  // ================= INIT =================
  ngOnInit(): void {
    this.readRoute();
    this.token = localStorage.getItem('accessToken') || '';
    this.loadAttendanceCache();

    this.currentSlot = this.getCurrentSlot();
    this.updateAttendancePercent();

    if (!localStorage.getItem(this.LS_ONBOARDING)) {
      this.showOnboarding = true;
    }

    this.startTimer();

    this.initHubs(this.courseStartId);
  }
  private loadAttendanceCache(): void {
    const raw = localStorage.getItem(this.ATTENDANCE_CACHE_KEY);
    if (!raw) return;

    const cache = JSON.parse(raw);
    const course = cache[this.courseStartId];
    if (!course) return;

    this.attendanceCache = {
      courseStartId: this.courseStartId,
      totalSessionHours: course.totalSessionHours,
      slotCount: course.slotCount ?? 1,
      attendanceDuration: course.attendanceDuration ?? 0,
      yoklamaPeriyodu: course.yoklamaPeriyodu ?? 'saatbasi',
      ogrenciDersSaatleri: course.ogrenciDersSaatleri || [],
    };

    this.checkOnboarding();
  }
  cameraPermissionState: PermissionState | null = null;
  locationPermissionState: PermissionState | null = null;
  async getCameraPermissionState(): Promise<PermissionState | null> {
  // iOS Safari uyumluluğu için
  if (!navigator.permissions || !navigator.permissions.query) {
    try {
      // Sessizce bir stream dene ve hemen kapat
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      stream.getTracks().forEach(t => t.stop());
      return 'granted';
    } catch (e: any) {
      return e.name === 'NotAllowedError' ? 'denied' : 'prompt';
    }
  }

  try {
    const res = await navigator.permissions.query({ name: 'camera' as any });
    return res.state;
  } catch {
    return null;
  }
}

  async getLocationPermissionState(): Promise<PermissionState | null> {
    try {
      const res = await navigator.permissions.query({ name: 'geolocation' });
      return res.state;
    } catch {
      return null;
    }
  }
  async initPermissions(): Promise<void> {
    this.cameraPermissionState = await this.getCameraPermissionState();
    this.locationPermissionState = await this.getLocationPermissionState();
  if (!this.onboardingInitialized) {
    this.checkOnboarding();
    this.onboardingInitialized = true;
  }
  }


  private isPermissionBlocked(state: PermissionState | null): boolean {
  return state === 'denied';

}
 private onboardingInitialized = false;
 private checkOnboarding(): void {
  if (this.onboardingLocked) return; // 🔥 KRİTİK

  const cameraDenied = this.isPermissionBlocked(this.cameraPermissionState);
  const locationDenied = this.isPermissionBlocked(this.locationPermissionState);

  const cameraRequired = this.qrUretAktif;
  const locationRequired = this.konumKontrolAktif;

  this.cameraPermissionDenied = cameraRequired && cameraDenied;

  this.locationAllowed = !locationRequired ? true : !locationDenied;

  const alreadySeen = localStorage.getItem(this.LS_ONBOARDING) === '1';

  const needCamera = cameraRequired && cameraDenied;
  const needLocation = locationRequired && locationDenied;

  this.showOnboarding = (needCamera || needLocation) && !alreadySeen;
}
  private updateAttendanceCacheFromApi(rawList: any[]): void {
    const raw = localStorage.getItem(this.ATTENDANCE_CACHE_KEY);
    if (!raw) return;

    const cache = JSON.parse(raw);
    const course = cache[this.courseStartId];
    if (!course) return;

    rawList.forEach((incoming: any) => {
      incoming.attendance?.forEach((slot: any) => {
        const existingSlot = course.ogrenciDersSaatleri.find(
          (s: any) => s.slotNumber === slot.slotNumber,
        );

        if (existingSlot) {
          existingSlot.katildiMi = slot.katildiMi;
        } else {
          course.ogrenciDersSaatleri.push({
            slotNumber: slot.slotNumber,
            katildiMi: slot.katildiMi,
          });
        }
      });
    });

    // tekrar yaz
    localStorage.setItem(this.ATTENDANCE_CACHE_KEY, JSON.stringify(cache));

    // 🔥 memory’deki cache’i de güncelle (KRİTİK)
    this.attendanceCache = {
      courseStartId: this.courseStartId,
      totalSessionHours: course.totalSessionHours,
      slotCount: course.slotCount ?? 1,
      attendanceDuration: course.attendanceDuration ?? 0,
      yoklamaPeriyodu: course.yoklamaPeriyodu ?? 'saatbasi',
      ogrenciDersSaatleri: course.ogrenciDersSaatleri,
    };

    // 🔥 UI tetikle
    this.updateAttendancePercent();
  }
  getAttendancePercentFromCache(): number {
    if (!this.attendanceCache || !this.attendanceCache.ogrenciDersSaatleri)
      return 0;

    const attended = this.attendanceCache.ogrenciDersSaatleri.filter(
      (s) => s.katildiMi,
    ).length;
    const total =
      this.attendanceCache.totalSessionHours ||
      this.attendanceCache.ogrenciDersSaatleri.length;

    return total === 0 ? 0 : Math.round((attended / total) * 100);
  }

  isSlotAttended(slotNumber: number): boolean {
    return !!this.attendanceCache?.ogrenciDersSaatleri?.some(
      (s) => s.slotNumber === slotNumber && s.katildiMi,
    );
  }

  private updateAttendancePercent(): void {
    const raw = localStorage.getItem(this.ATTENDANCE_CACHE_KEY);
    if (!raw) {
      this.attendancePercent = 0;
      return;
    }

    const cache = JSON.parse(raw);
    const course = cache[this.courseStartId];
    if (!course) {
      this.attendancePercent = 0;
      return;
    }

    const slots = course.ogrenciDersSaatleri || [];
    const attended = slots.filter((s: any) => s.katildiMi).length;
    const total = course.totalSessionHours || slots.length;

    this.attendancePercent =
      total === 0 ? 0 : Math.round((attended / total) * 100);
  }
  private getCurrentSlot(): number {
    const raw = localStorage.getItem(this.ATTENDANCE_CACHE_KEY);
    if (!raw) return 1;

    const cache = JSON.parse(raw);
    const course = cache[this.courseStartId];
    if (!course) return 1;

    const slot = course.ogrenciDersSaatleri.find((s: any) => !s.katildiMi);

    const slotNumber = slot?.slotNumber;

    return !slotNumber || slotNumber <= 0 ? 1 : slotNumber;
  }

  ngOnDestroy(): void {
    clearInterval(this.timerRef);
    clearInterval(this.scanIntervalRef);
    this.stopCamera();
    this.hub?.stop();
    this.qrHub?.stop();
    this.attendanceHub?.stop();
  }

  serverTime: any;
  private serverOffsetMs = 0;
  async getTimeExample(): Promise<Date | null> {
    const s = await this.utcTimeService.fetchUtcTime();
    this.serverTime = s; // setState yerine direkt property'yi güncelliyoruz
    return this.serverTime;
  }
  async initServerTime(): Promise<void> {
    const serverDate = await this.getTimeExample();
    if (!serverDate) return;

    this.serverOffsetMs = serverDate.getTime() - Date.now();
  }
  // ================= TIMER =================
  private startTimer(): void {
    const startMs = this.createdDate.getTime();
    const endMs = startMs + this.attendanceDuration * 60 * 1000;

    const tick = () => {
      const nowMs = Date.now() + this.serverOffsetMs;
      const diff = Math.floor((endMs - nowMs) / 1000);

      this.remainingSeconds = Math.max(diff, 0);

      // Buton kontrolünü buraya ekleyelim
      this.butonGoster = this.remainingSeconds > 0;

      if (diff <= 0) {
        clearInterval(this.timerRef);
        this.remainingSeconds = 0;
        this.stopCamera();
      }
    };

    tick(); // hemen çalıştır
    this.timerRef = setInterval(tick, 1000);
  }

  goBack(): void {
    window.history.back();
  }

  formatTime(): string {
    if (
      !this.remainingSeconds ||
      isNaN(this.remainingSeconds) ||
      this.remainingSeconds <= 0
    ) {
      this.butonGoster = false; // ⬅ butonları kapat
      return '00:00';
    }

    this.butonGoster = true; // ⬅ butonları aç

    const m = Math.floor(this.remainingSeconds / 60);
    const s = this.remainingSeconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  }

  private showIOSCameraInfoOnce(): void {
    if (!this.isIOS()) return;

    if (localStorage.getItem(this.LS_KEYS.IOS_CAMERA_INFO)) return;

    this.alertService.message(
      'iPhone’da kamera izni için Ayarlar > Safari > Kamera > İzin Ver açık olmalı.',
      'Bilgilendirme',
      {
        messageType: ToastrMessageType.Warning,
        position: ToastrPosition.TopFullWidth,
      },
    );

    localStorage.setItem(this.LS_KEYS.IOS_CAMERA_INFO, '1');
  }
  private async isInAllowedArea(
    centerLat: number,
    centerLng: number,
    maxDistance: number,
  ): Promise<{ status: LocationStatus }> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const accuracy = pos.coords.accuracy;

          const distance = this.getDistance(
            centerLat,
            centerLng,
            pos.coords.latitude,
            pos.coords.longitude,
          );

          // ❗ kötü sinyal → WARNING ama izin ver
          if (accuracy > 120) {
            resolve({ status: LocationStatus.WARNING });
            return;
          }

          // OK
          if (distance <= maxDistance) {
            resolve({ status: LocationStatus.OK });
            return;
          }

          // sınır dışı ama yine WARNING (bloklama yok)
          resolve({ status: LocationStatus.WARNING });
        },
        () => {
          reject(LocationStatus.FAIL);
        },
        { enableHighAccuracy: true },
      );
    });
  }
  konumDisiMi: boolean = false;
  // ================= LOCATION =================
  async checkLocation(): Promise<void> {
    this.showIOSLocationInfoOnce();
    this.showAndroidLocationInfoOnce();

    try {
      const result = await this.isInAllowedArea(
        this.latitude,
        this.longitude,
        this.maxDistanceMeter,
      );

      if (result.status === LocationStatus.OK) {
        this.locationAllowed = true;
        this.konumDisiMi = false; // ✅ içeride
        return;
      }

      if (result.status === LocationStatus.WARNING) {
        this.locationAllowed = true; // izin veriyoruz
        this.konumDisiMi = true; // ⚠️ konum dışı say

        this.alertService.message(
          '📍 Konum doğruluğu çok düşük! Sistem sizi binanın dışında görebilir. Lütfen Ayarlar > Safari/Chrome > Konum > "Kesin Konum"u açın. Ders sorumlusuna onaylatmanız gerekebilir.',
          'Uyarı',
          {
            messageType: ToastrMessageType.Warning,
            position: ToastrPosition.TopFullWidth,
          },
        );

        return;
      }

      // FAIL
      this.locationAllowed = false;
      this.konumDisiMi = true;
    } catch {
      this.locationAllowed = false;
      this.konumDisiMi = true;

      this.alertService.message('Konum alınamadı / izin verilmedi', 'Hata', {
        messageType: ToastrMessageType.Error,
        position: ToastrPosition.TopFullWidth,
      });
    }
  }
  clearPermissionInfos(): void {
    Object.values(this.LS_KEYS).forEach((k) => localStorage.removeItem(k));
  }
  private showAndroidLocationInfoOnce(): void {
    if (!this.isAndroid()) return;

    if (localStorage.getItem(this.LS_KEYS.ANDROID_LOCATION_INFO)) return;

    this.alertService.message(
      'Android cihazlarda daha iyi sonuç için Konum Doğruluğu yüksek olmalıdır.',
      'Bilgi',
      {
        messageType: ToastrMessageType.Info,
        position: ToastrPosition.TopFullWidth,
      },
    );

    localStorage.setItem(this.LS_KEYS.ANDROID_LOCATION_INFO, '1');
  }

  private getDistance(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
  ): number {
    const R = 6371000;
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) ** 2;

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  private deg2rad(v: number): number {
    return v * (Math.PI / 180);
  }

  // ================= CAMERA =================
// ================= CAMERA =================
async openCamera(): Promise<void> {
  this.showIOSCameraInfoOnce();

  if (this.remainingSeconds <= 0) {
    this.alertService.message('Süre Doldu', 'Hata', {
      messageType: ToastrMessageType.Error,
      position: ToastrPosition.TopFullWidth,
    });
    return;
  }

  if (this.konumKontrolAktif && !this.locationAllowed) {
    this.alertService.message('Konum İzni Gerekli', 'Hata', {
      messageType: ToastrMessageType.Error,
      position: ToastrPosition.TopFullWidth,
    });
    return;
  }

  try {
    this.cameraOpen = true;
    this.qrRead = false;

    this.stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: { ideal: 'environment' }
      }
    });

    const videoEl = this.video.nativeElement;

    videoEl.srcObject = this.stream;
    videoEl.muted = true;
    videoEl.playsInline = true;

    await new Promise<void>((resolve, reject) => {
      videoEl.onloadedmetadata = async () => {
        try {
          await videoEl.play();
          resolve();
        } catch (err) {
          reject(err);
        }
      };
    });

    this.startScanner();
  } catch (err) {
    console.error('Camera error:', err);
    this.cameraOpen = false;
  }
}
private startScanner(): void {
  this.stopScanner(); // önce temizle

  this.scanIntervalRef = window.setInterval(() => {
    this.scanQR();
  }, 300);
}private stopScanner(): void {
  if (this.scanIntervalRef) {
    clearInterval(this.scanIntervalRef);
    this.scanIntervalRef = null;
  }
}

private stopCamera(): void {
  if (this.stream) {
    this.stream.getTracks().forEach(t => t.stop());
    this.stream = null;
  }

  this.cameraOpen = false;
}
private scanQR(): void {
  if (this.qrRead || this.remainingSeconds <= 0) return;

  const video = this.video.nativeElement;

  if (!video.videoWidth || !video.videoHeight) return;

  const canvas = this.canvas.nativeElement;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });

  if (!ctx) return;

  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;

  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

  const img = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const code = jsQR(img.data, canvas.width, canvas.height);

  if (!code?.data) return;

  this.qrRead = true;

  navigator.vibrate?.(100);

  this.stopScanner();
  this.stopCamera();

  const finalUrl = this.enrichQrUrlForWeb(code.data);
  this.sendAttendance(finalUrl);
}
  haftalikDersId = 0; // route paramsdan alınacak
  acilanDersNo?: number; // route paramsdan alınacak
  acilanDersDetayNo?: number;
  teacherId?: number; // route paramsdan alınacak
  akademikPersonelNo?: number; // route paramsdan alınacak
  isAllTaken?: boolean; // route paramsdan alınacak

  slotSayisi = 0; // route paramsdan alınacak

  dersBaslangic!: any; // route paramsdan alınacak
  dersBitis!: any; // route paramsdan alınacak

  // ================= ROUTE =================
  private readRoute(): void {
    const q = this.route.snapshot.queryParams;
    const yoklamaNo = q['yoklamaNo'];

    const key = `courseStudent_${yoklamaNo}`;
    const data = localStorage.getItem(key);

    if (!data) return;

    const d = JSON.parse(data);

    this.ogrenciNo = d.ogrenciNo;
    this.courseStartId = +d.courseStartId;
    this.attendanceDuration = +d.attendanceDuration;
    this.haftalikDersId = +d.haftalikDersId;
    this.studentName = d.studentName;
    this.studentSurname = d.studentSurname;
    this.ogrenciDersNo = +d.ogrenciDersNo || 0;
    this.slotSayisi = +d.slotCount || 1;
    this.lessonName = d.derSube;
    this.lessonSalaon = d.derslik;

    this.acilanDersDetayNo = +d.acilanDersDetayNo;
    this.acilanDersNo = +d.acilanDersNo;

    this.akademikPersonelNo = +d.akademikPersonelNo || 0;
    this.teacherId = +d.akademikPersonelNo || 0;

    this.isAllTaken = d.isAllTaken;

    this.lessonStartTime = d.saat.split('-')[0].slice(0, 5);
    this.lessonEndTime = d.saat.split('-')[1].slice(0, 5);
    this.lessonGun = d.gunler;

    this.latitude = +d.latitude;
    this.longitude = +d.longitude;

    this.qrUretAktif = d.qrUretAktif;
    this.konumKontrolAktif = d.konumKontrolAktif;

    this.createdDate = d.createdDate ? new Date(d.createdDate) : new Date();

    const saatRange = d.saat?.split('-') || ['00:00:00', '00:00:00'];

    this.dersBaslangic = this.parseTime(saatRange[0]);
    this.dersBitis = this.parseTime(saatRange[1]);
  }

  ogrNo = this.ogrenciNo;
  /**
   * 🔹 Web tarafında QR URL’sini güncelle ve eksikleri ekle
   */
  private enrichQrUrlForWeb(baseUrl: string): string {


    const q = this.route.snapshot.queryParams;
    const yoklamaNo = q['yoklamaNo'];
    const key = `courseStudent_${yoklamaNo}`;
    const data = localStorage.getItem(key);

    if (!data) return baseUrl;

    const d = JSON.parse(data);
    this.ogrNo = d.ogrenciNo ?? 0;
    const uri = new URL(baseUrl);
    const params = new URLSearchParams(uri.search);

    // -------------------- 1️⃣ Değiştirilenler --------------------
    params.set('studentId', d.ogrenciNo.toString());
    params.set('ogrenciDersNo', d.ogrenciDersNo.toString());
    params.set('slotCount', this.currentSlot.toString());
    params.set('isAllTaken', d.isAllTaken?.toString() ?? 'false');
    params.set(
      'konumDisi',
      d.konumKontrolAktif ? this.konumDisiMi.toString() : 'false',
    );
    params.set('qrUretAktif', d.qrUretAktif.toString());
    params.set('konumKontrolAktif', d.konumKontrolAktif.toString());
    params.set('obsStatus', 'false');
    params.set('qrRead', 'true');
    params.set('attendanceSource', d.qrUretAktif ? 'qr_scan' : 'self_button');
    params.set('katildimi', 'true');

    // -------------------- 2️⃣ Eklenenler --------------------
    if (!params.has('acilanDersDetayNo'))
      params.set('acilanDersDetayNo', d.acilanDersDetayNo?.toString() ?? '');

    if (!params.has('akademikPersonelNo'))
      params.set('akademikPersonelNo', d.akademikPersonelNo?.toString() ?? '');

    if (!params.has('acilanDersNo'))
      params.set('acilanDersNo', d.acilanDersNo?.toString() ?? '');

    if (!params.has('studentName')) params.set('studentName', d.studentName);

    if (!params.has('studentSurname'))
      params.set('studentSurname', d.studentSurname);

    if (!params.has('token'))
      params.set('token', this.tokenQr?.toString() ?? '');

    uri.search = params.toString();
    return uri.toString();
  }
  private enrichQrUrlWithStudentData(baseUrl: string): string {


    const q = this.route.snapshot.queryParams;
    const yoklamaNo = q['yoklamaNo'];
    const key = `courseStudent_${yoklamaNo}`;
    const data = localStorage.getItem(key);

    if (!data) return baseUrl;

    const d = JSON.parse(data);
    this.ogrNo = d.ogrenciNo ?? 0;
    const uri = new URL(baseUrl);
    const newParams = new URLSearchParams(uri.search);
    const slotNumber = d.isAllTaken ? '1' : this.currentSlot.toString(); //kontrol şart


    newParams.set('studentId', d.ogrenciNo.toString());
    newParams.set('ogrenciDersNo', d.ogrenciDersNo.toString());
    newParams.set('teacherId', d.akademikPersonelNo?.toString() ?? '');
    newParams.set('slotCount', slotNumber);
    newParams.set('slotNumber', slotNumber);
    newParams.set('isAllTaken', d.isAllTaken?.toString() ?? 'false');
    newParams.set(
      'konumDisi',
      d.konumKontrolAktif ? this.konumDisiMi.toString() : 'false',
    );
    newParams.set('qrUretAktif', d.qrUretAktif.toString());
    newParams.set('konumKontrolAktif', d.konumKontrolAktif.toString());
    newParams.set('obsStatus', 'false');
    newParams.set('qrRead', d.qrUretAktif ? 'true' : 'false');
    newParams.set('katildimi', 'true');
    newParams.set(
      'attendanceSource',
      d.qrUretAktif ? 'qr_scan' : 'self_button',
    );

    newParams.set('acilanDersDetayNo', d.acilanDersDetayNo?.toString() ?? '');

    newParams.set('akademikPersonelNo', d.akademikPersonelNo?.toString() ?? '');

    newParams.set('acilanDersNo', d.acilanDersNo?.toString() ?? '');
    newParams.set('studentName', d.studentName);
    newParams.set('studentSurname', d.studentSurname);
    newParams.set('token', this.tokenQr.toString());

    uri.search = newParams.toString();
    return uri.toString();
  }

  parseTime = (timeStr: string, referenceDate: Date = new Date()) => {
    // timeStr format: "HH:mm:ss" veya "HH:mm"
    const parts = (timeStr || '00:00:00')
      .split(':')
      .map((p) => parseInt(p, 10));
    const hours = parts[0] || 0;
    const minutes = parts[1] || 0;
    const seconds = parts[2] || 0;

    return new Date(
      referenceDate.getFullYear(),
      referenceDate.getMonth(),
      referenceDate.getDate(),
      hours,
      minutes,
      seconds,
    );
  };
  // ================= QR / Buradayım =================
  async handleAttendanceClick(): Promise<void> {
    if (this.qrUretAktif && !this.cameraPermissionDenied) {
      // QR aktifse kamerayı aç
      this.openCamera();
      return;
    }

    if (this.remainingSeconds <= 0) {
      this.alertService.message('Süre doldu', 'Hata', {
        messageType: ToastrMessageType.Error,
        position: ToastrPosition.TopFullWidth,
      });
      return;
    }

    if (this.konumKontrolAktif && !this.locationAllowed) {
      this.alertService.message('Konum izni gerekli', 'Hata', {
        messageType: ToastrMessageType.Error,
        position: ToastrPosition.TopFullWidth,
      });
      return;
    }

    const baseUrl = environment.baseUrl + '/Yoklama/AddAttendanceRecord';
    const finalUrl = `${baseUrl}?courseId=${this.courseStartId}&course_startId=${this.courseStartId}&yoklamaNo=${this.haftalikDersId}`;
    const newUrl = await this.enrichQrUrlWithStudentData(finalUrl);

    this.sendAttendance(newUrl);
  }
  private async sendAttendance(finalUrl: string): Promise<void> {
    if (this.remainingSeconds <= 0) {
      this.alertService.message('Süre doldu', 'Hata', {
        messageType: ToastrMessageType.Error,
        position: ToastrPosition.TopFullWidth,
      });
      return;
    }

    this.loading = true;
    try {
      var response = await this.httpService.getUrl(finalUrl);

      if (Array.isArray(response)) {

        this.applyAttendanceUpdate(response);
        this.updateAttendanceCacheFromApi(response);

        this.attendanceSuccess = true;

        this.alertService.message('Yoklama alındı', 'Başarılı', {
          messageType: ToastrMessageType.Success,
          position: ToastrPosition.TopFullWidth,
        });
      } else {
        console.warn('Beklenmeyen response:', response);

        this.alertService.message('Yoklama alınamadı', 'Hata', {
          messageType: ToastrMessageType.Error,
          position: ToastrPosition.TopFullWidth,
        });
      }
    } catch (err) {
      this.loading = false;
      console.error('sendAttendance error', err);

      this.alertService.message('Yoklama alınamadı', 'Hata', {
        messageType: ToastrMessageType.Error,
        position: ToastrPosition.TopFullWidth,
      });
    }
  }

  // Yeni method: slot için class döndürüyor
  getSlotClass(slot: any, info: any): string {
    if (!info) return 'upcoming';

    // Henüz gelinmemiş saat
    const aktifSlot = info.totalSessionHours - info.slotCount;

    if (slot.slotNumber > aktifSlot) {
      return 'upcoming';
    }

    // Katıldı / Katılmadı
    return slot.katildiMi ? 'present' : 'absent';
  }

  // ================= SIGNALR =================
  async connectToQrHub(courseStartId: number): Promise<void> {
    try {

      if (this.qrHub) {

        await this.qrHub.stop();
        this.qrHub = undefined;

      }

      this.qrHub = new HubConnectionBuilder()
        .withUrl(environment.baseUrl.split('api')[0] + 'qrtokenhub', {
          accessTokenFactory: async () => this.token,
          transport: HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect()
        .build();

      this.qrHub.on('ReceiveNewToken', (data: any) => {


        // Eğer hub tek obje gönderiyorsa args değil direkt data
        const token = data?.token ?? '';
        const courseStartId = data?.courseStartId ?? 0;

        if (token) {
          this.tokenQr = token;

        } else {
          console.warn('⚠ ReceiveNewToken: Token yok veya boş!', data);
        }
      });

      this.qrHub.on('QrSessionExpired', () => {

        this.tokenQr = '';
      });

      await this.qrHub.start();


      await this.qrHub.invoke(
        'SubscribeToCourseStart',
        courseStartId,
        this.courseStartId,
        this.haftalikDersId,
        this.currentSlot,
        this.attendanceDuration,
        this.qrUretAktif,
        this.konumKontrolAktif,
        this.acilanDersDetayNo,
        this.akademikPersonelNo,
        this.acilanDersNo,
      );

    } catch (e) {
      console.error('❌ QR Hub error:', e);
    }
  }
  private applyAttendanceUpdate(rawList: any[] | null | undefined): void {
    if (!Array.isArray(rawList)) return;



    // sadece ilgili öğrenci
    const incoming = rawList.find(
      (s: any) => Number(s.studentId) === Number(this.ogrNo),
    );

    if (!incoming) return;

    const mappedAttendance = (incoming.attendance ?? []).map((slot: any) => ({
      attendanceRecordId: slot.attendanceRecordId,
      slotNumber: slot.slotNumber,
      katildiMi: slot.katildiMi,
      konumDisi: slot.konumDisi,
      qrRead: slot.qrRead,
    }));

    const existing = this.students.find(
      (s) => Number(s.studentId) === Number(this.ogrNo),
    );

    if (existing) {
      existing.attendance = mappedAttendance;
    } else {
      this.students.push({
        studentId: incoming.studentId,
        studentName: incoming.studentName,
        studentSurName: incoming.studentSurName,
        ogrenciDersNo: incoming.ogrenciDersNo,
        attendance: mappedAttendance,
      });
    }
  }
  private getTotalMinutes(): number {
    // Dersin toplam süresi dakika cinsinden
    const diffMs = this.dersBitis.getTime() - this.dersBaslangic.getTime();
    return Math.max(0, Math.floor(diffMs / (60 * 1000)));
  }

  totalSession(): number {
    // Dersin kaç saat sürdüğünü bul, her saat bir slot
    const minutes = this.getTotalMinutes();
    return Math.max(1, Math.ceil(minutes / 60));
  }

  generateSlotLabels(): string[] {
    const labels: string[] = [];
    const dersSuresiDakika = 40; // 50 dk ders
    const araDakika = 10; // 10 dk aralar

    const slots = this.totalSession(); // slot sayısı ders bitiş - başlangıç ile

    let current = new Date(this.dersBaslangic);

    for (let i = 0; i < slots; i++) {
      const slotBaslangic = new Date(current);
      const slotBitis = new Date(
        slotBaslangic.getTime() + dersSuresiDakika * 60000,
      );

      const basSaat = slotBaslangic.getHours().toString().padStart(2, '0');
      const basDakika = slotBaslangic.getMinutes().toString().padStart(2, '0');
      const bitSaat = slotBitis.getHours().toString().padStart(2, '0');
      const bitDakika = slotBitis.getMinutes().toString().padStart(2, '0');

      labels.push(`${basSaat}:${basDakika} - ${bitSaat}:${bitDakika}`);

      // Son slot değilse arayı ekle
      if (i !== slots) {
        current = new Date(slotBitis.getTime() + araDakika * 60000);
      }
    }

    return labels;
  }
  // Tüm hubları başlatmak için helper
  async initHubs(courseStartId: number) {
    await this.connectToQrHub(courseStartId);
  }
}
